/// <amd-module name="xss/PresetOptions" />
import { IFilterXSSOptions, whiteList } from "xss";

export const superAllowList: IFilterXSSOptions = {
    allowList: {
        ...whiteList,
        "div": ['style'],
        "span": ['style']
    }
};

export const xssStyleDefaultOptions: IFilterXSSOptions = {
    // This replaces the roosterjs-html-sanitizer attributeCallback method
    // as "xss" does not have this functionality.
    ...superAllowList,
    onIgnoreTagAttr: (tag, name, value) => {
        if (name === "style") {
            return value.replace(/(height|line-height)\s*:.+?(;[\s]?|$)/g, "");
        }
    }
}
